import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import Form, { ButtonItem, ButtonOptions, GroupItem, Item, Label, RequiredRule, CheckBox, TabbedItem, TabPanelOptions, Tab } from "devextreme-react/form";
import Request from "../../../components/api/Request";
import * as AppActions from '../../../actions/AppActions';
import { ToastType } from "../../../constants/Constants";
import { showToast, parseDate, parseApiDate, showDialog } from "../../../utils/Utils";
import CustomStore from "devextreme/data/custom_store";
import { TextBox, Button as TextBoxButton } from 'devextreme-react/text-box';

const DomainDetay = (props) => {

    const dispatch = useDispatch();

    const [domain, setDomain] = useState();
    const [storeTesvikKanunu, setStoreTesvikKanunu] = useState([]);
    const [storeBeyanTesvikKanunu, setStoreBeyanTesvikKanunu] = useState([]);

    const [isyeriSifreMod, setIsyeriSifreMod] = useState("password");
    const [sistemSifreMod, setSistemSifreMod] = useState("password");
    const [faturaBilgiDisabled, setFaturaBilgiDisabled] = useState(false);
    const [faturaBilgiVisible, setFaturaBilgiVisible] = useState(true);
    

    useEffect(() => {
        getTesvikKanunu();
        getDomain();

        if (window.location.hostname.includes("tesvikmaster") || window.location.hostname.includes("trwturkiye")) {
            setFaturaBilgiVisible(false);
        } else {
            setFaturaBilgiVisible(true);
        }
    }, [])
    const getTesvikKanunu = () => {
        const request = new Request("/tesvikkanunu/getTesvikSelectList", "GET");
        request.run()
            .then(response => {
                if (response.data) {
                    setStoreTesvikKanunu(response.data.data);
                    setStoreBeyanTesvikKanunu(response.data.data);
                } else {
                    setStoreBeyanTesvikKanunu([]);
                    return setStoreTesvikKanunu([]);
                }
            });

    }


    const getDomain = () => {

        let data = { state: true };
        if (props.data.id) {
            const request = new Request("/domain/getKayit/" + props.data.id, "GET");
            return request.run()
                .then(response => {
                    if (response.data) {
                        data = response.data.data

                    }
                    data.baslangicTarihi = parseDate(data.baslangicTarihi);
                    data.bitisTarihi = parseDate(data.bitisTarihi);
                    data.yatirimTesvikBaslamaTarihi = parseDate(data.yatirimTesvikBaslamaTarihi);
                    data.yatirimTesvikBitisTarihi = parseDate(data.yatirimTesvikBitisTarihi);

                    setFaturaBilgiDisabled(data.parent == null);
                    setDomain(data);
                });
        } else if (props.data.parent) {
            const request = new Request("/domain/getKayit/" + props.data.parent.id, "GET");
            return request.run()
                .then(response => {

                    if (response.data) {
                        data = { parent: response.data.data };
                    }
                    data.baslangicTarihi = parseDate(data.baslangicTarihi);
                    data.bitisTarihi = parseDate(data.bitisTarihi);
                    data.yatirimTesvikBaslamaTarihi = parseDate(data.yatirimTesvikBaslamaTarihi);
                    data.yatirimTesvikBitisTarihi = parseDate(data.yatirimTesvikBitisTarihi);
                    data.state = true;
                    setDomain(data);
                    setIsyeriSifreMod("text");
                    setSistemSifreMod("text");
                    setFaturaBilgiDisabled(data.parent == null);
                });
        } else {
            setDomain(data);
            setIsyeriSifreMod("text");
            setSistemSifreMod("text");
            setFaturaBilgiDisabled(data.parent == null);
        }


    }
    function kaydet(e) {

        let eksikBilgi = false;
        e.validationGroup.validators.map((a) => {
            if (a.validate().status !== "valid") {
                eksikBilgi = true;
            }
        }
        );
        if (eksikBilgi) {
            showToast('Zorunlu alanları kontrol ediniz', ToastType.ERROR, 500);
            return;
        }
        let data = domain;

        if(!faturaBilgiDisabled && faturaBilgiVisible){
            if (data.anlasmaOran != null && data.anlasmaTutar != null) {
                showToast('Fatura bilgilerini kontrol ediniz', ToastType.ERROR, 500);
                return;
            }
            
            let anlamaTutarVeyaOranGirilmis = (data.anlasmaOran != null && data.anlasmaOran >0 ) ||  (data.anlasmaTutar != null && data.anlasmaTutar >0);
            let ariIkOranGirilmis = data.ariIkOran != null && data.ariIkOran >0 ;
    
            if (anlamaTutarVeyaOranGirilmis && !ariIkOranGirilmis) {
                showToast('Fatura bilgilerini kontrol ediniz (Ari-Ik oranı girilmemiş)', ToastType.ERROR, 500);
                return;
            }
    
            if (data.sozlesmeli != null && data.sozlesmeli) {
                if (!anlamaTutarVeyaOranGirilmis || !ariIkOranGirilmis) {
                    showToast('Fatura bilgilerini kontrol ediniz', ToastType.ERROR, 500);
                    return;
                }
            }  
        }

  
        

        ///ariIkOran
        //sozlesmeli


        data.baslangicTarihi = parseApiDate(data.baslangicTarihi);
        data.bitisTarihi = parseApiDate(data.bitisTarihi);
        data.yatirimTesvikBaslamaTarihi = parseApiDate(data.yatirimTesvikBaslamaTarihi);
        data.yatirimTesvikBitisTarihi = parseApiDate(data.yatirimTesvikBitisTarihi);





        if (data.parent != null) {
            data.parent.parent = undefined;
        }


        let url = "/domain/createKayit";
        const request = new Request(url, "POST", data);
        dispatch(AppActions.setLoading(true, "Kayıt işlemi yapılıyor.."));
        return request.run()
            .then(response => {
                dispatch(AppActions.setLoading(false, ""));
                if (response.data && response.data.success) {
                    props.hide();
                } else {
                    let mesaj = "";
                    if (response && response.response && response.response.data && response.response.data.message) {
                        mesaj = response.response.data.message;
                    }
                    showDialog({ title: 'Firma kayıt', message: mesaj, buttons: "OK" });
                }
            });
    }
    function showIsyeriSifre() {

        if (isyeriSifreMod == "password") {
            const request = new Request("/domain/getIsyeriSifre/" + domain.id, "GET");
            request.run()
                .then(response => {
                    //debugger;
                    if (response.data && response.data.data) {
                        setDomain(Object.assign({}, domain, {
                            isyeriSifre: response.data.data
                        }));
                        setIsyeriSifreMod("text");
                    }
                });
        } else {
            setIsyeriSifreMod("password");
        }
    }
    function showSistemSifre() {
        if (sistemSifreMod == "password") {
            const request = new Request("/domain/getSistemSifre/" + domain.id, "GET");
            request.run()
                .then(response => {
                    //debugger;
                    if (response.data && response.data.data) {
                        setDomain(Object.assign({}, domain, {
                            sifre: response.data.data
                        }));
                        setSistemSifreMod("text");
                    }
                });

        } else {
            setSistemSifreMod("password");
        }

    }

    return (
        <div >
            <Form formData={domain} colCount={1} id="form" labelLocation={"left"} className="option" >
                <TabbedItem editorOptions={{ height: 260 }}>
                    <TabPanelOptions deferRendering={false} />
                    <Tab title="Genel Bilgileri">
                        <Item itemType="group" colCount={1} colSpan={1}>
                            <Item disabled={true} dataField={'parent.name'} editorType={'dxTextBox'} >
                                <Label text='Üst Firma' />
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={1} colSpan={1}>
                            <Item disabled={false} dataField={'name'} editorType={'dxTextBox'}>
                                <RequiredRule message="Adı bilgisi gerekli" />
                                <Label text='Adı' />
                            </Item>
                        </Item>


                        <Item itemType="group" colCount={3} colSpan={3}>
                            <Item disabled={false} dataField={'state'} editorType={'dxCheckBox'}>
                                <Label text='Durum' />
                            </Item>

                            <Item
                                dataField={'baslangicTarihi'}
                                editorType={'dxDateBox'}
                                editorOptions={{ stylingMode: 'outlined', type: "date", displayFormat: "dd.MM.yyyy" }}
                            >
                                <Label text='Başlangıç Tar' />
                            </Item>
                            <Item
                                dataField={'bitisTarihi'}
                                editorType={'dxDateBox'}
                                editorOptions={{ stylingMode: 'outlined', type: "date", displayFormat: "dd.MM.yyyy" }}
                            >
                                <Label text='Bitiş Tar' />
                            </Item>
                        </Item>

                        <Item itemType="group" colCount={1} colSpan={1}>
                            <Item disabled={false} dataField={'mailAddress'} editorType={'dxTextBox'}    >
                                <Label text='E-Mail' />
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={1} colSpan={1}>
                            <Item disabled={false} dataField={'domainNot'} editorType={'dxTextArea'} editorOptions={{ height: 60 }}>
                                <Label text='Firma Not' />
                            </Item>
                        </Item>
                    </Tab>
                    <Tab title="Sgk Bilgileri" disabled={faturaBilgiDisabled}>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'sicilNo'} editorType={'dxTextBox'}>
                                <Label text='Sicil No' />
                            </Item>
                            <Item itemType="group" colCount={2} colSpan={2}>
                                <Item disabled={false} dataField={'araciNo'} editorType={'dxTextBox'} editorOptions={{ stylingMode: 'outlined' }}>
                                    <Label text='Aracı No' />
                                </Item>
                                <Item disabled={false} dataField={'ilPlaka'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 81, min: 1, showSpinButtons: true }}>
                                    <Label text='İl Plaka' />
                                </Item>

                            </Item>

                        </Item>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'kullaniciAdi'} editorType={'dxTextBox'}>
                                <Label text='Kullancı Adı' />
                            </Item>
                            <Item disabled={false} dataField={'isYeriKod'} editorType={'dxTextBox'}>
                                <Label text='İşyeri Kod' />
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'sifre'} editorType={'dxTextBox'}
                                editorOptions={{
                                    mode: sistemSifreMod,
                                    buttons: [
                                        { name: 'trash', location: 'after', options: { stylingMode: 'text', icon: 'refresh', onClick: () => { showSistemSifre(); } } }
                                    ]
                                }} >
                                <Label text='Sistem Şifresi' />
                            </Item>
                            <Item disabled={false} dataField={'isyeriSifre'} editorType={'dxTextBox'}
                                editorOptions={{
                                    mode: isyeriSifreMod,
                                    buttons: [
                                        { name: 'trash', location: 'after', options: { stylingMode: 'text', icon: 'refresh', onClick: () => { showIsyeriSifre(); } } }
                                    ]
                                }} >
                                <TextBoxButton
                                    name="password"
                                    location="after"
                                //options={this.passwordButton}
                                />
                                <Label text='İşyeri Şifresi' />
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'tesvikDriverCount'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 20, min: 1, showSpinButtons: true }}>
                                <Label text='Teşvik Kanal Sayısı' />
                            </Item>
                            <Item itemType="group" colCount={2} colSpan={2}>
                                <Item disabled={false} dataField={'isbasiTesvikAktif'} editorType={'dxCheckBox'}>
                                    <Label text='İşbaşı Teşvik' />
                                </Item>
                                <Item disabled={false} dataField={'autoOnay'} editorType={'dxCheckBox'}>
                                    <Label text='Auto Teşvik Onay' />
                                </Item>
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'vergino'} editorType={'dxTextBox'}>
                                <Label text='Vergi-no' />
                            </Item> 
                            {/* <Item disabled={false} dataField={'diplomaOnayIptal6111'} editorType={'dxCheckBox'}>
                                <Label text='Dip. Onay İpt.' />
                            </Item> */}

                             <Item itemType="group" colCount={2} colSpan={2}>
                                <Item disabled={false} dataField={'ihale'} editorType={'dxCheckBox'}>
                                    <Label text='İhale' />
                                </Item>
                                <Item disabled={false} dataField={'diplomaOnayIptal6111'} editorType={'dxCheckBox'}>
                                    <Label text='Dip. Onay İpt.' />
                                </Item>
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'isverenSorguDakika'} editorType={'dxNumberBox'}>
                                <Label text='İsveren Sorgu Ar.' />
                            </Item>
                        </Item>
                    </Tab>
                    <Tab title="Yatırım Teşviği" disabled={faturaBilgiDisabled}>
                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'yatirimTesvikKodu'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 10000000, min: 0, showSpinButtons: true }}>
                                <Label text='Kodu' />
                            </Item>
                            <Item
                                dataField={'yatirimTesvikBaslamaTarihi'}
                                editorType={'dxDateBox'}
                                editorOptions={{ stylingMode: 'outlined', type: "date", displayFormat: "dd.MM.yyyy" }}
                            >
                                <Label text='Başlangıç Tar' />
                            </Item>


                        </Item>

                        <Item itemType="group" colCount={2} colSpan={2}>
                            <Item disabled={false} dataField={'yatirimTesvikIlave'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 10000, min: 0, showSpinButtons: true }}>
                                <Label text='ilave' />
                            </Item>
                            <Item
                                dataField={'yatirimTesvikBitisTarihi'}
                                editorType={'dxDateBox'}
                                editorOptions={{ stylingMode: 'outlined', type: "date", displayFormat: "dd.MM.yyyy" }}
                            >
                                <Label text='Bitiş Tar' />
                            </Item>
                        </Item>
                        <Item itemType="group" colCount={2} colSpan={2}>

                            <Item disabled={false} dataField={'yatirimTesvikSayi'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 10000, min: 0, showSpinButtons: true }}>
                                <Label text='Sayı' />
                            </Item>
                        </Item>
                    </Tab>

                    <Tab title="Dahil Edilmeyecek Kanun Bilgileri" disabled={!faturaBilgiDisabled}>
                        <Item colSpan={1}
                            dataField={'appDomainExecludeBeyanTesvikIdList'}
                            editorType={'dxTagBox'}
                            editorOptions={
                                {
                                    //value:'appDomainExecludeBeyanTesvikIdList',
                                    valueExpr: "id",
                                    displayExpr: "kanunNumarasi",
                                    placeholder: "Select a value...",
                                    stylingMode: 'outlined',
                                    showClearButton: true,
                                    dataSource: storeBeyanTesvikKanunu,

                                }
                            } >
                            <Label text='İhale' />
                        </Item>
                        <Item colSpan={1}
                            dataField={'appDomainExecludeTesvikIdList'}
                            editorType={'dxTagBox'}
                            editorOptions={
                                {
                                    //value:'appDomainExecludeTesvikIdList',
                                    valueExpr: "id",
                                    displayExpr: "kanunNumarasi",
                                    placeholder: "Select a value...",
                                    stylingMode: 'outlined',
                                    showClearButton: true,
                                    dataSource: storeTesvikKanunu,

                                }
                            } >
                            <Label text='Teşvikler' />
                        </Item>
                    </Tab>

                    <Tab title="Fatura Bilgileri" disabled={!faturaBilgiDisabled}  visible={faturaBilgiVisible} >
                        <Item disabled={false} dataField={'anlasmaOran'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 100, min: 0, showSpinButtons: true }}>
                            <Label text='Anlaşma Oranı' />
                        </Item>
                        <Item disabled={false} dataField={'anlasmaTutar'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 1000000, min: 0, showSpinButtons: true }}>
                            <Label text='Anlaşma Tutarı' />
                        </Item>
                        <Item disabled={false} dataField={'ariIkOran'} editorType={'dxNumberBox'} editorOptions={{ stylingMode: 'outlined', max: 1000000, min: 0, showSpinButtons: true }}>
                            <Label text='Ari-ik Tutarı' />
                        </Item>
                        <Item disabled={false} dataField={'sozlesmeli'} editorType={'dxCheckBox'}>
                            <Label text='Sözleşmeli' />
                        </Item>

                    </Tab>

                </TabbedItem>

                <ButtonItem>
                    <ButtonOptions
                        onClick={(e) => { kaydet(e); }}
                        width={'100%'}
                        type={'success'}
                        useSubmitBehavior={true}>
                        <span className="dx-button-text">
                            {'Kaydet'
                            }
                        </span>
                    </ButtonOptions>
                </ButtonItem>

            </Form>


        </div>
    )
}

export default DomainDetay;
